import { createIcon } from '@/utils/factoryUtil'

export const SVGBrandManaPool = createIcon('SVGBrandManaPool', (props) => (
  <svg viewBox='0 0 100 100' {...props}>
    <polygon points='72.5 59.03 72.5 50.26 55.52 54.91 55.52 63.68 72.5 59.03' />
    <path d='M57.94,0L6.58,14.02v68.83l34.18,17.15,52.67-14.45V16.72S57.94,0,57.94,0ZM83.01,67.98l-25.63,7.17v10.13l-12.9,3.37v-55.62l19.26,7.15,19.27-17.69v45.5Z' />
  </svg>
))
